import * as  ActionTypes from "../../Actions/DriverLog/ActionTypes"
import * as ActionReducer from "./ActionReducer"
import {getDriverChangeCorrdinateSuccessAction} from "../../Actions/DriverLog/Action";

const initialState = {
  getDriverLog: {
    request: null,
    response: null,
    error: null,
  },
  getDriverLogCorrdinate: {
    request: null,
    response: null,
    error: null,
  },
    updateChangeLocationStatus: {
        request: null,
        response: null,
        error: null,
    },
    planChangeStatusesExcel: {
        request: null,
        response: null,
        error: null,
    },
};

const DriverLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_DRIVER_LOG:
      return ActionReducer.getDriverLog(state, action);
    case ActionTypes.GET_DRIVER_LOG_SUCCESS:
      return ActionReducer.getDriverLogSuccess(state, action);
    case ActionTypes.GET_DRIVER_LOG_FAIL:
      return ActionReducer.getDriverLogFail(state, action);

    case ActionTypes.GET_DRIVER_CHANGE_COORDINATE_LOGS:
        return ActionReducer.getDriverLogCorrdinate(state, action);
    case ActionTypes.GET_DRIVER_CHANGE_COORDINATE_LOGS_SUCCESS:
        return ActionReducer.getDriverLogCorrdinateSuccess(state, action);
    case ActionTypes.GET_DRIVER_CHANGE_COORDINATE_LOGS_FAIL:
        return ActionReducer.getDriverLogCorrdinateFail(state, action);

    case ActionTypes.UPDATE_CHANGE_LOCATION_STATUS:
        return ActionReducer.updateChangeLocationStatus(state, action);
    case ActionTypes.UPDATE_CHANGE_LOCATION_STATUS_SUCCESS:
        return ActionReducer.updateChangeLocationStatusSuccess(state, action);
    case ActionTypes.UPDATE_CHANGE_LOCATION_STATUS_FAIL:
        return ActionReducer.updateChangeLocationStatusFail(state, action);

    case ActionTypes.GET_PLAN_CHANGE_STATUSES_EXCEL:
        return ActionReducer.getPlanChangeStatusesExcel(state);
    case ActionTypes.GET_PLAN_CHANGE_STATUSES_EXCEL_SUCCESS:
        return ActionReducer.getPlanChangeStatusesExcelSuccess(state, action);
    case ActionTypes.GET_PLAN_CHANGE_STATUSES_EXCEL_FAIL:
        return ActionReducer.getPlanChangeStatusesExcelFail(state, action);
    case ActionTypes.CLEAR_PLAN_CHANGE_STATUSES_EXCEL:
        return ActionReducer.clearPlanChangeStatusesExcel(state);

    default:
      return state;
  }
};

export { DriverLogReducer };
